import axios from "axios";
import authHeader from "@/services/auth-header";
import { ApiService } from "@/services/api.service";
import environments from "../utils/environments";
import { Vendor } from "@/models/vendor";

const API_URL = environments.apiUrl + "/api/vendors";

class VendorService {
  getAllVendors() {
    return ApiService.get(API_URL + "");
  }

  createNewVendor(vendor: Vendor) {
    return ApiService.post(API_URL + "/create", vendor);
  }

  updateVendor(vendor: Vendor) {
    return ApiService.post(API_URL + "/update", vendor);
  }

  searchVendor(search: string) {
    return ApiService.get(API_URL + "/search/" + search);
  }
}

export default new VendorService();
